import { useSelector } from "react-redux";

import { getLivestockSaleId } from "lib/navigation";
import { getBestMatchingSplit } from "lib/splits";

import {
  selectBuyerSplitByKeyLookup,
  selectVendorSplitByKeyLookup,
} from "selectors";

interface Props {
  primaryBusinessId: string;
  deploymentId: number;
  consignmentId?: string;
  saleLotId?: string;
}

export const useGetBestMatchingVendorSplit = ({
  primaryBusinessId,
  deploymentId,
  consignmentId,
  saleLotId,
}: Props): VendorSplit | undefined => {
  const splitByKeyLookup = useSelector(selectVendorSplitByKeyLookup);
  const livestockSaleId = getLivestockSaleId();
  return getBestMatchingSplit({
    splitByKeyLookup,
    primaryBusinessId,
    deploymentId,
    livestockSaleId,
    consignmentId,
    saleLotId,
  }) as VendorSplit;
};

export const useGetBestMatchingBuyerSplit = ({
  primaryBusinessId,
  deploymentId,
  consignmentId,
  saleLotId,
}: Props): BuyerSplit | undefined => {
  const splitByKeyLookup = useSelector(selectBuyerSplitByKeyLookup);
  const livestockSaleId = getLivestockSaleId();
  return getBestMatchingSplit({
    splitByKeyLookup,
    primaryBusinessId,
    deploymentId,
    livestockSaleId,
    consignmentId,
    saleLotId,
  }) as BuyerSplit;
};
